import { TableColumnType, Table } from '@/components';
import { RoomLookupDto, CategoryLookupDto } from '@/core';
import {
  BaselineSpecialRequestState,
  BaselinePersonalizationItemState,
} from '@/redux';

interface Props {
  name: string;
  columns: TableColumnType<BaselinePersonalizationTableRow>[];
  dataSource: BaselinePersonalizationTableRow[];
  loading?: boolean;
}

export interface BaselinePersonalizationTableRow {
  number: number | null;
  room: RoomLookupDto | null;
  isFloorplan: boolean;
  name: string;
  categoryPath: CategoryLookupDto[];
  description: string | null;
  specialRequest?: BaselineSpecialRequestState;
  personalizationItem?: BaselinePersonalizationItemState;
  isExistingItem?: boolean;
  projectName: string;
  createdAt: string;
}

export function BaselinePersonalizationTablePanel(props: Props) {
  const { name, columns, dataSource, loading } = props;
  return (
    <Table<BaselinePersonalizationTableRow>
      name={name}
      columns={columns}
      dataSource={dataSource}
      pagination={false}
      loading={loading}
      hideDefaultActions
    />
  );
}
